/* ============================================================
   HAGI FRAGRANCES — MAIN JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Custom Cursor ───────────────────────────────────── */
  const cursor     = document.querySelector('.cursor');
  const cursorRing = document.querySelector('.cursor-ring');

  if (cursor && cursorRing && window.innerWidth > 768) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });

    (function animateRing() {
      rx += (mx - rx) * 0.11;
      ry += (my - ry) * 0.11;
      cursorRing.style.left = rx + 'px';
      cursorRing.style.top  = ry + 'px';
      requestAnimationFrame(animateRing);
    })();

    document.querySelectorAll('a, button, .product-feature-img, .collection-card, .related-item, .note-pill').forEach(el => {
      el.addEventListener('mouseenter', () => { cursorRing.classList.add('hover'); cursor.classList.add('expand'); });
      el.addEventListener('mouseleave', () => { cursorRing.classList.remove('hover'); cursor.classList.remove('expand'); });
    });
  }

  /* ── Navigation: scroll state ───────────────────────── */
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav ──────────────────────────────────────── */
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => mobileNav.classList.add('open'));
    if (mobileClose) mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('open')));
  }

  /* ── Scroll Reveal ───────────────────────────────────── */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    reveals.forEach(el => revealObserver.observe(el));
  }

  /* ── Product Hero: Ken Burns effect ─────────────────── */
  const productHero = document.querySelector('.product-hero');
  if (productHero) setTimeout(() => productHero.classList.add('loaded'), 80);

  /* ── Product Gallery Thumbnails ──────────────────────── */
  const mainImg = document.querySelector('.product-gallery-main');
  const thumbs  = document.querySelectorAll('.product-gallery-thumb');

  if (mainImg && thumbs.length) {
    thumbs[0]?.classList.add('active');
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = thumb.src;
          mainImg.style.opacity = '1';
        }, 220);
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    mainImg.style.transition = 'opacity 0.3s ease';
  }

  /* ── Hero Video: mobile & error fallback ─────────────── */
  const heroVideo  = document.querySelector('.hero-video');
  const heroPoster = document.querySelector('.hero-poster');

  if (heroVideo) {
    if (window.innerWidth <= 768) {
      heroVideo.style.display = 'none';
      if (heroPoster) heroPoster.style.display = 'block';
    }
    heroVideo.addEventListener('error', () => {
      heroVideo.style.display = 'none';
      if (heroPoster) heroPoster.style.display = 'block';
    });
  }

  /* ── Forms: real submit with visual feedback ─────────── */
  /* The form posts natively to Shopify (/contact, form_type=customer).
     Shopify redirects back with ?customer_posted=true, where we show
     the confirmation state. */
  document.querySelectorAll('.footer-form, .waitlist-form').forEach(form => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('button');
      if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }
    });
  });

  if (window.location.search.indexOf('customer_posted=true') > -1) {
    document.querySelectorAll('.footer-form, .waitlist-form').forEach(form => {
      const input = form.querySelector('input[type="email"]');
      const btn   = form.querySelector('button');
      if (btn) { btn.textContent = 'Received'; btn.style.background = '#3a6a3a'; }
      if (input) { input.value = ''; input.placeholder = 'Thank you — you are on the list.'; }
    });
  }

});
